import axios from '@plugins/axios'
import getSecret from '@utils/get-secret'
let serverUrl = getSecret('SERVER_URL');
import i18n from '@plugins/i18n'
export const state = {
  references : {}
}

export const mutations = {
  SET_REFERENCES(state, value) {
    state.references = value
  }
}
export const getters = {
    getReferenceFields() {
      return {model: 'repositories_reference', 
              label: 'References',
              fields: [
                { key: 'name', label: 'Name', type: 'text', sortable: true, required: true },
                { key: 'description', label: 'Description', type: 'text', sortable: true, required: false }
              ]}
    },
    getReferences(state) {
      return state.references
    }
  }

  export const actions = {
    async fetchReferences({ commit, state }, query = '') {
      return axios
      .get(`${serverUrl}/api/masters/references/${query}`)
        .then((response) => {
          commit('SET_REFERENCES', response.data)
          return response.data;   
        })
    },
    
    async createReferences({ commit, state }, { payload }) {
      return axios
        .post(`${serverUrl}/api/masters/references/`, payload)
        .then((response) => {
          return response.data;
        })
    },
  
    async updateReferences(context, { payload }) {
      return axios
      .patch(`${serverUrl}/api/masters/references/${payload.id}/`, payload)
        .then((response) => {
          return response.data;
        })
    },
  
    async deleteReferences(context, { id }) {
      return axios
      .delete(`${serverUrl}/api/masters/references/${id}/`)
        .then((response) => {
          return response.data;
        })
    },
    fetchReferencesOptions(context, query) {
      query = query || ''
      return axios.options(`${serverUrl}/api/masters/references/${query}`).then((response) => {
        return response.data
      })
    },
  }